import { Component, Input, OnInit, OnChanges, EventEmitter, Output } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss'],
  animations: [
    trigger('flyInOut', [
      state('in', style({ transform: 'translateY(0)' })),
      transition('void => *', [
        style({ transform: 'translateY(-100%)' }),
        animate(200)
      ]),
      transition('* => void', [
        animate(200, style({ transform: 'translateY(100%)' }))
      ])
    ])
  ]
})
export class AlertMessageComponent implements OnInit, OnChanges {

  @Input() code: string;
  type: string;
  message: string;
  language: string = 'en';

  @Output() close = new EventEmitter();

  constructor() {}

  ngOnInit() {
    this.interpretCode();
  }

  ngOnChanges() {
    this.interpretCode();
  }

  /**
   * @param: none
   * @return: alert message
   */
  interpretCode() {
    switch(this.code) {
      case '':
      case undefined:
        this.type = undefined;
        this.message = undefined;
        break;
      case 'auth/sign-in-ok':
        this.type = 'success';
        if (this.language=='fr')
          this.message = 'Connexion réussie.';
        else this.message = 'Successfully signed in.';
        break;
      case 'auth/sign-in-ko':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Connexion impossible.';
        else this.message = 'Unable to sign in.';
        break;
      case 'user/get-info-ok':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Récupération des données utilisateur réussie.';
        else this.message = 'Successfully retrieved user infos.';
        break;
      case 'user/get-info-ko':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Récupération des données utilisateur impossible.';
        else this.message = 'Unable to retrieve user infos.';
        break;
      case 'auth/sign-out-ok':
        this.type = 'success';
        if (this.language=='fr')
          this.message = 'Déconnexion réussie.';
        else this.message = 'Successfully signed out.';
        break;
      case 'auth/sign-out-ko':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Déconnexion impossible.';
        else this.message = 'Unable to sign out.';
        break;
      case 'param/components-benchmarks-required':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Un benchmark doit être spécifié pour chaque composant.';
        else this.message = 'You must specify a benchmark for each component.';
        break;
      case 'param/one-component-needed':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Au moins un composant doit être sélectionné.';
        else this.message = 'You must select at least one component.';
        break;
      case 'param/one-fund-needed':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Au moins un fond doit être sélectionné.';
        else this.message = 'You must select at least one fund.';
        break;
      case 'param/benchmark-required':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Vous devez sélectionner un benchmark.';
        else this.message = 'You must select a benchmark.';
        break;
      case 'param/no-portfolio-name':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Vous devez donner un nom au portefeuille.';
        else this.message = 'No name specified for portfolio.';
        break;
      case 'param/invalid':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Paramètres invalides.';
        else this.message = 'Invalid parameters.';
        break;
      case 'param/normalization':
        this.type = 'warning';
        if (this.language=='fr')
          this.message = 'Une normalisation sera appliquée pour que la somme des poids soit unitaire.';
        else this.message = 'A normalization will be applied so that weights sum up to one.';
        break;
      case 'portfolio/create-failed':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'La création du portefeuille a échoué.';
        else this.message = 'Portfolio creation failed.';
        break;
      case 'portfolio/create-success':
        this.type = 'success';
        if (this.language=='fr')
          this.message = 'La création du portefeuille a été effectuée.';
        else this.message = 'Portfolio successfully created.';
        break;
      case 'standalone/create-failed':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'La création du portefeuille standalone a échoué.';
        else this.message = 'Standalone portfolio creation failed.';
        break;
      case 'standalone/create-success':
        this.type = 'success';
        if (this.language=='fr')
          this.message = 'La création du portefeuille standalone a été effectuée.';
        else this.message = 'Standalone portfolio successfully created.';
        break;
      case 'strategy/create-failed':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'La création de la stratégie a échoué.';
        else this.message = 'Factor strategy creation failed.';
        break;
      case 'strategy/create-success':
        this.type = 'success';
        if (this.language=='fr')
          this.message = 'La création de la stratégie a été effectuée.';
        else this.message = 'Factor strategy successfully created.';
        break;
      case 'completeness/too_few_ingredients':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Deux ou plus ingrédients de complétude doivent être sélectionnées.';
        else this.message = 'Please select two or more completeness ingredients.';
        break;
      case 'watchlist/create-failed':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'La création de la watchlist a échoué.';
        else this.message = 'Watchlist creation failed.';
        break;
      case 'watchlist/create-success':
        this.type = 'success';
        if (this.language=='fr')
          this.message = 'La création de la watchlist a été effectuée.';
        else this.message = 'Watchlist successfully created.';
        break;
      case 'investable/create-failed':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'La création du portefeuille investissable a échoué.';
        else this.message = 'Investable portfolio creation failed.';
        break;
      case 'investable/create-success':
        this.type = 'success';
        if (this.language=='fr')
          this.message = 'La création du portefeuille investissable a été effectuée.';
        else this.message = 'Investable portfolio successfully created.';
        break;
      case 'protected/create-failed':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'La création du portefeuille protégé a échoué.';
        else this.message = 'Protected portfolio creation failed.';
        break;
      case 'protected/create-success':
        this.type = 'success';
        if (this.language=='fr')
          this.message = 'La création du portefeuille protégé a été effectuée.';
        else this.message = 'Protected portfolio successfully created.';
        break;
      case 'data/import-failed':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'L\'importation des données a échoué.';
        else this.message = 'Data importation failed.';
        break;
      case 'data/import-success':
        this.type = 'success';
        if (this.language=='fr')
          this.message = 'L\'importation des données a été effectuée.';
        else this.message = 'Data successfully imported.';
        break;
      case 'cluster/update-failed':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'La mise à jour des données du cluster a échoué.';
        else this.message = 'Cluster update failed.';
        break;
      case 'cluster/update-success':
        this.type = 'success';
        if (this.language=='fr')
          this.message = 'La mise à jour des données du cluster a été effectuée.';
        else this.message = 'Cluster successfully updated.';
        break;
      case 'watchlist/delete-failed':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'La suppression watchlist a échoué.';
        else this.message = 'Watchlist deletion failed.';
        break;
      case 'watchlist/delete-success':
        this.type = 'success';
        if (this.language=='fr')
          this.message = 'La suppression de la watchlist a été effectuée.';
        else this.message = 'Watchlist successfully deleted.';
        break;
      case 'computation-failed':
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Le calcul a échoué.';
        else this.message = 'Computation failed.';
        break;
      case 'computation-success':
        this.type = 'success';
        if (this.language=='fr')
          this.message = 'Le calcul a été effectué avec succès.';
        else this.message = 'Computation successfully completed.';
        break;
      default:
        this.type = 'danger';
        if (this.language=='fr')
          this.message = 'Une erreur est survenue.'
        else this.message = 'An error has occured.'
    }
  }

  onClose() {
    this.close.emit();
  }

}
